import { CommonModule, DatePipe } from "@angular/common";
import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { forkJoin, Observable } from "rxjs";
import { SimpleChanges, OnChanges } from "@angular/core";
import { GenericRequestCalendarDto } from "../../../../core/models/common/genericRequestCalendarDto";
import { GenericFilterRequestDto } from "../../../../core/models/generic-filter-request.dto";
import { GetAllTaskResponse } from "../../../../core/models/task-management/getAllTaskResponseDto";
import { GetOverdueTasksRequestDto } from "../../../../core/models/task-management/getOverdueTasksRequestDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { PriorityTypeEnums } from "../../../../shared/enums/priorityTypeEnum";
import { EnumSalesTaskStatus } from "../../../../shared/enums/salesTaskStatus";
import { TaskTypeEnum } from "../../../../shared/enums/taskTypeEnum";
import {
  CalendarViewTypeSubSelectionEnum,
  ViewTypeEnum,
} from "../../../../shared/enums/viewTypeEnum";
import { WorkflowStatusEnum } from "../../../../shared/enums/workflowStatusEnum";
import {
  getColorForName,
  getTextColorForName,
  replaceString,
} from "../../../../shared/globalfunction";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CalendarOptions, EventInput } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import {
  FullCalendarComponent,
  FullCalendarModule,
} from "@fullcalendar/angular";
import { SkeletonModule } from "primeng/skeleton";
import { DialogModule } from "primeng/dialog";
import { TooltipModule } from "primeng/tooltip";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { avatarUserDetailsDto } from "../../../../core/models/task-management/avatar-user-details";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { UserAvatarDetailsComponent } from "../../user-avatar-details/user-avatar-details.component";
import { Popover, PopoverModule } from "primeng/popover";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { GetUserAvatarDetailsDto } from "../../../../core/models/users/users/getUserAvatarDetailsDto";
import { GetAllAssignedUsers } from "../../../../core/models/task-management/getAllAssignedUsersDto";
import { DatePickerModule } from "primeng/datepicker";
import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { GetTaskListDto } from "../../../../core/models/task-management/getTaskListDto";
import { UpdateTaskLine } from "../../../../core/models/task-management/updateTaskLineDto";
import { createCommentDto } from "../../../../core/models/task-management/createCommentDto";
import { InputTextModule } from "primeng/inputtext";
import { SelectModule } from "primeng/select";
import { ProjectWorkflowService } from "../../../../core/services/project-workflow.service";
import { TaskHeaderEditComponent } from "../../task-header-edit/task-header-edit.component";
import { DragDropModule } from "primeng/dragdrop";
import { AddTaskOrder } from "../../../../core/models/task-management/addTaskOrderDto";
import { ConfirmDialogComponent } from "../../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "jni-calendar-view",
  templateUrl: "./calendar-view.component.html",
  styleUrls: ["./calendar-view.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    SkeletonModule,
    FullCalendarModule,
    DialogModule,
    TooltipModule,
    UserAvatarDetailsComponent,
    PopoverModule,
    DatePickerModule,
    ConfirmDialogModule,
    InputTextModule,
    SelectModule,
    TaskHeaderEditComponent,
    DragDropModule,
    ConfirmDialogComponent,
  ],
  providers: [DatePipe, ConfirmationService],
})
export class CalendarViewComponent implements AfterViewInit, OnChanges {
  @Input() globalFilter!: GenericFilterRequestDto[];
  @Input() taskType!: number;
  @Input() myTasks!: boolean;
  @Input() archivedTasks!: boolean;
  @Output() emitShowContactDialog = new EventEmitter<string>();
  @Output() emitShowSalesOrderSummaryModal = new EventEmitter<string>();
  @Output() emitShowWorkflowSummaryModal = new EventEmitter<{
    salesOrderId: string;
    workflowId: number;
  }>();
  lazyLoadEvent!: GenericFilterRequestDto[];
  @Input() allAssignedUserList: GetAllAssignedUsers[] = [];
  taskIdSelected = 0;
  products = [];
  displayAddTaskModal = false;
  displayTaskDetailModal = false;
  showTaskModal = false;
  showSummarykModal = false;
  displaySidebar = false;
  showEditTaskModal = false;
  taskList: GetAllTaskResponse[] = [];
  defaultTake = 250;
  totalRecords = 0;
  //filterTextChanged: Subject<any> = new Subject<any>();
  filterDebounceTime = 1000;
  dropIndex = 0;
  status = new Map<string, string>([]);
  activeListing: Map<string, GetAllTaskResponse[]> = new Map<
    string,
    GetAllTaskResponse[]
  >();
  tasksArray: { date: string; tasks: GetAllTaskResponse[] }[] = [];
  visibleDays: number =
    typeof window !== "undefined" && window.innerWidth <= 1366 ? 2 : 3;
  draggedTask: GetAllTaskResponse | null | undefined;
  draggedFromDate: string | null = null;
  draggedFromOverdue = false;
  dataSet: GetAllTaskResponse[] = [];
  overdueTasks: GetAllTaskResponse[] = [];
  TaskTypeEnum = TaskTypeEnum;
  @Input() durationSelected!: string;
  startDate: Date = new Date();
  endDate!: Date;
  loaderState = false;
  showUserAvatarDetails = false;
  userAvatorDetails = {} as avatarUserDetailsDto;
  @ViewChild("userAvatarDetailsComp", { static: false })
  userAvatarDetailsComp!: UserAvatarDetailsComponent;
  @ViewChild("avatarUserPopover") avatarUserPopover!: Popover;
  @ViewChild("statusOverlay") statusOverlay!: Popover;

  private hideTimeout: ReturnType<typeof setTimeout> | null = null;
  private currentAvatarTarget: HTMLElement | null = null;

  // Pagination properties for Overdue tasks
  overduePageNumber = 1;
  overduePageSize = 50;
  hasMoreOverdueTasks = true;
  isLoadingMoreOverdue = false;
  totalOverdueRecords = 0;

  // Title editing properties
  editingTaskId: number | null = null;
  originalTitle: string | null = null;

  // Status dropdown properties
  statusList!: { label: string; value: string | EnumSalesTaskStatus }[];
  prodStatusDropDownList!: { label: string; value: number }[];
  workflowStatusList!: Record<string, number>;
  currentProductForStatus: GetAllTaskResponse | null = null; // Store the current product for status change

  taskTypeKey: Record<number, string> = {
    [TaskTypeEnum.Sales]: "Sales Task",
    [TaskTypeEnum.Production]: "Production Task",
  };

  calendarOptions: CalendarOptions = {
    initialView: "dayGridMonth",
    plugins: [dayGridPlugin],
    headerToolbar: {
      center: "small medium large",
    },
    customButtons: {
      small: {
        text: "Small",
        click: this.smallView.bind(this),
      },
      medium: {
        text: "Medium",
        click: this.mediumView.bind(this),
      },
      large: {
        text: "Large",
        click: this.largeView.bind(this),
      },
      next: {
        click: this.nextMonth.bind(this),
      },
      prev: {
        click: this.prevMonth.bind(this),
      },
      today: {
        text: "Today",
        click: this.today.bind(this),
      },
    },
    showNonCurrentDates: false,
    fixedWeekCount: false,
    dayMaxEventRows: 1,
    dayMaxEvents: 1,
    height: 700,
    contentHeight: 600,
    eventClassNames: arg => {
      if (
        this.isTaskType(
          arg.event.extendedProps?.["taskType"],
          TaskTypeEnum.Sales
        )
      ) {
        return ["purple"];
      }
      if (
        this.isTaskType(
          arg.event.extendedProps?.["taskType"],
          TaskTypeEnum.Production
        )
      ) {
        return ["blue"];
      }
      return [];
    },
  };

  eventsPromise!: Promise<EventInput[]>;

  @ViewChild("fullCalendar") fullCalendar!: FullCalendarComponent;
  @ViewChild("calendarContainer") calendarContainer!: ElementRef;
  @ViewChildren("scrollContainer") scrollContainers!: QueryList<ElementRef>;
  @ViewChild("scrollOverDueContainer") scrollOverDueContainer!: ElementRef;

  @ViewChild("taskHeaderEdit", { static: false })
  taskHeaderEdit!: TaskHeaderEditComponent;

  // Scroll position preservation for seamless edits
  private savedScrollPositions: { scrollTop: number; scrollLeft: number }[] =
    [];
  private shouldRestoreScroll = false;

  private savedOverdueScrollTop = 0;
  private savedOverdueScrollLeft = 0;
  private shouldRestoreOverdueScroll = false;
  taskStatusKeyPairsSales: Record<number, string> = {
    [EnumSalesTaskStatus.New]: "New",
    [EnumSalesTaskStatus.Blocked]: "Blocked",
    [EnumSalesTaskStatus.InProgress]: "In Progress",
    [EnumSalesTaskStatus.InReview]: "In Review",
    [EnumSalesTaskStatus.Closed]: "Closed",
  };

  taskStatusKeyPairsProduction: Record<number, string> = {
    [WorkflowStatusEnum.ALL]: "All",
    [WorkflowStatusEnum.Cancelled]: "Cancelled",
    [WorkflowStatusEnum.Complete]: "Complete",
    [WorkflowStatusEnum.Delivered]: "Delivered",
    [WorkflowStatusEnum.InProduction]: "In Production",
    [WorkflowStatusEnum.OrderWritten]: "Order Written",
    [WorkflowStatusEnum.PoSent]: "Po Sent",
    [WorkflowStatusEnum.ProjectCreated]: "Project Created",
    [WorkflowStatusEnum.ProofApproved]: "Proof Approved",
    [WorkflowStatusEnum.ProofSent]: "Proof Sent",
    [WorkflowStatusEnum.RevisionRequested]: "Revision Requested",
    [WorkflowStatusEnum.Shipped]: "Shipped",
  };

  priorityLevelSales: Record<number, string> = {
    [PriorityTypeEnums.Urgent]: "Urgent",
    [PriorityTypeEnums.Source]: "Source",
    [PriorityTypeEnums.Order]: "Order",
    [PriorityTypeEnums.Standard]: "Standard",
  };

  priorityLevelProduction: Record<number, string> = {
    [PriorityTypeEnums.Urgent]: "Urgent",
    [PriorityTypeEnums.Standard]: "Standard",
  };

  priorityColorSales: Record<number, string> = {
    [PriorityTypeEnums.Urgent]: "#ff4d4d",
    [PriorityTypeEnums.Source]: "#6666ff",
    [PriorityTypeEnums.Order]: "#ffc966",
    [PriorityTypeEnums.Standard]: "#fff",
  };

  priorityColorProduction: Record<number, string> = {
    [PriorityTypeEnums.Urgent]: "#ff4d4d",
    [PriorityTypeEnums.Standard]: "#fff",
  };
  small = false;
  medium = true;
  large = false;
  isLoading = false;
  profilePictures = new Map<string, SafeUrl | null>();
  archiveMessage = "You want to mark <b>{0}</b> as {1}.";
  archiveAlertVisible = false;
  archivedTask = 0;
  archivedTaskStatus = false;
  // Store current filters for reuse in pagination methods
  private currentFilters: GenericFilterRequestDto[] = [];

  constructor(
    private _taskManagement: TaskManagementService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _profileFormService: ProfileFormService,
    private _domSanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private _msalApiService: MsalApiService,
    private sanitizer: DomSanitizer,
    private confirmationService: ConfirmationService,
    private _workflowService: ProjectWorkflowService
  ) {
    effect(() => {
      const state = this._loaderService.status$;
      this.loaderState = state();
    });
  }

  ngAfterViewInit(): void {
    this.statusList = this.getSalesTaskAsList();
    this.getWorkflowStatusList();
    this.getAllTaskList(this.globalFilter);
    //this.setLoaderState();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["myTasks"] && changes["myTasks"].previousValue !== undefined) {
      this.myTasks = changes["myTasks"].currentValue;
      this.getAllTaskList(this.lazyLoadEvent);
    }
    if (
      changes["archivedTasks"] &&
      changes["archivedTasks"].previousValue !== undefined
    ) {
      this.archivedTasks = changes["archivedTasks"].currentValue;
      this.getAllTaskList(this.lazyLoadEvent);
    }
  }

  setLoaderState() {
    effect(() => {
      const state = this._loaderService.status$;
      this.loaderState = state();
    });
  }

  triggerFunction(
    globalFilterValue: GenericFilterRequestDto[],
    taskType?: number,
    durationType?: string
  ) {
    if (taskType) {
      this.taskType = taskType;
    }
    if (durationType) {
      this.durationSelected = durationType;
    }
    this.getAllTaskList(globalFilterValue);
  }

  getAllTaskList(globalFilterValue?: GenericFilterRequestDto[]) {
    this._loaderService.setLoaderState(true);

    // Reset pagination for overdue tasks
    this.overduePageNumber = 1;
    this.hasMoreOverdueTasks = true;

    if (this.taskType) {
      const taskFilter = {
        columnName: "TaskType",
        matchMode: "equals",
        tableName: "UserTasks",
        value: Number(this.taskType) !== 0 ? this.taskType.toString() : "",
      };

      if (globalFilterValue) {
        const existingIndex = globalFilterValue.findIndex(
          (filter: { columnName: string; tableName: string }) =>
            filter.columnName === "TaskType" && filter.tableName === "UserTasks"
        );

        if (existingIndex !== -1) {
          globalFilterValue[existingIndex] = taskFilter;
        } else {
          globalFilterValue.push(taskFilter);
        }
      } else {
        globalFilterValue = [taskFilter];
      }
    }

    // Store filters for reuse in pagination methods
    this.currentFilters = globalFilterValue ?? [];

    const request: GenericRequestCalendarDto = {
      skip: 0,
      take: this.totalRecords || 1000,
      filters: globalFilterValue ?? [],
      skipPagination: true,
      sort: [],
      // For Weekly view: FromDate = Today (25 Feb), ToDate = Day After Tomorrow (27 Feb)
      // This will fetch ONLY 3 days of data: 25 Feb, 26 Feb, 27 Feb
      // Convert to ISO date string (YYYY-MM-DD) to avoid timezone issues
      FromDate:
        this.durationSelected === "Daily" || this.durationSelected === "Weekly"
          ? this.getOnlyDateString(this.getFromDate())
          : this.getFromDate(),
      ToDate:
        this.durationSelected === "Daily" || this.durationSelected === "Weekly"
          ? this.getOnlyDateString(this.getToDate())
          : this.getToDate(),
      listViewType: ViewTypeEnum.Calendar,
      myTask: this.myTasks,
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      archivedTask: this.archivedTasks,
      caLendarViewTypeSubSelection: this.calendarViewSubSelection(),
    };

    // Configure overdue tasks request based on view type
    const overdueRequest: GetOverdueTasksRequestDto = {
      pageNumber: this.overduePageNumber,
      pageSize: this.durationSelected === "Daily" ? 100 : this.overduePageSize, // Backend max limit is 100
      isAllOverdue: true, // Fetch ALL overdue tasks for both Weekly and Daily views
      myTask: this.myTasks,
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      archivedTask: this.archivedTasks,
      filters: globalFilterValue ?? [],
    };

    if (this.fullCalendar && this.durationSelected === "Monthly") {
      const calendarApi = this.fullCalendar.getApi();
      calendarApi.removeAllEvents();
    }

    // Use forkJoin to call both APIs simultaneously
    // For Daily and Weekly views, we fetch overdue tasks
    // For Monthly view, we skip overdue tasks API call
    const apiCalls: {
      tasks: Observable<GenericResponseDto<GetAllTaskResponse[]>>;
      overdueTasks?: Observable<GenericResponseDto<GetTaskListDto[]>>;
    } = {
      tasks: this._taskManagement.getAllProjectWorkFlowTaskList(request),
    };

    // Only call overdue API for Weekly and Daily views
    if (
      this.durationSelected === "Weekly" ||
      this.durationSelected === "Daily"
    ) {
      apiCalls.overdueTasks =
        this._taskManagement.getOverdueTasks(overdueRequest);
    }

    forkJoin(apiCalls).subscribe({
      next: async (result: {
        tasks: GenericResponseDto<GetAllTaskResponse[]>;
        overdueTasks?: GenericResponseDto<GetTaskListDto[]>;
      }) => {
        const res = result.tasks;
        const overdueRes = result.overdueTasks;

        this.activeListing.clear();
        this.overdueTasks = [];

        // Initialize swimlanes for the requested date range (Weekly/Daily)
        // This ensures swimlanes are shown even when no data is returned
        if (
          this.durationSelected === "Weekly" ||
          this.durationSelected === "Daily"
        ) {
          const distinctDueDates = this.getDatesBetween();
          distinctDueDates.forEach(date => {
            const formattedDate = date.toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              //timeZone: "UTC",
            });
            this.activeListing.set(formattedDate, []);
          });
        }

        // Process regular tasks (date-based swimlanes)
        if (res?.data) {
          this.totalRecords = res.totalRecords ?? 0;
          this.eventsPromise = new Promise<EventInput[]>(resolve => {
            const events: EventInput[] = [];
            res.data.forEach((task: GetAllTaskResponse) => {
              //const dueDate = task.dueDate ? task.dueDate.split('T')[0] : '';
              events.push({
                id: task.taskId.toString(),
                title: task.title,
                date: task.dueDate ? task.dueDate.split("T")[0] : "",
                interactive: task.isExternal && !task.isAdmin,
                extendedProps: {
                  isInternal: !task.isExternal || task.isAdmin,
                  assignedTo: task.assignedTo,
                  taskType: task.taskType,
                  assignedToUserId: task.assignedToUserId,
                },
              });

              // Only add non-overdue tasks to date-based swimlanes
              //if (!task.dueDatePassed) {
              const setDueDate = new Date(
                task.dueDate.split("T")[0]
              ).toLocaleDateString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                timeZone: "UTC", // Ensures UTC is used
              });
              if (this.activeListing.has(setDueDate)) {
                this.activeListing.get(setDueDate)!.push(task);
              } else {
                this.activeListing.set(setDueDate, [task]);
              }
              //}

              // Load profile picture for each task
              if (task.assignedToEmail) {
                this.loadProfilePicture(task.assignedToEmail);
              }
            });
            resolve(events);
          });
        }

        // Process overdue tasks from separate API
        if (overdueRes?.data) {
          if (this.durationSelected === "Weekly") {
            // Weekly view: Show in separate Overdue swimlane with infinite scroll
            this.totalOverdueRecords = overdueRes.totalRecords ?? 0;
            this.overdueTasks = this.convertToGetAllTaskResponse(
              overdueRes.data
            );
            this.hasMoreOverdueTasks =
              this.overdueTasks.length < this.totalOverdueRecords;

            // Load profile pictures for overdue tasks
            this.overdueTasks.forEach(task => {
              if (task.assignedToEmail) {
                this.loadProfilePicture(task.assignedToEmail);
              }
            });
          } else if (this.durationSelected === "Daily") {
            // Daily view: Merge ALL overdue tasks with daily tasks
            const allOverdueTasks = this.convertToGetAllTaskResponse(
              overdueRes.data
            );

            // Get the formatted date for the current day
            const currentDateKey = this.getFromDate().toLocaleDateString(
              "en-US",
              {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                //timeZone: "UTC",
              }
            );

            // Merge overdue tasks at the beginning of the daily task list
            if (this.activeListing.has(currentDateKey)) {
              const existingTasks =
                this.activeListing.get(currentDateKey) ?? [];
              const sortedOverDueTasks = this.sortDailyTasks(allOverdueTasks);
              // Sort the merged tasks: overdue first, then by priority
              const sortedTasks = this.sortDailyTasks(existingTasks);
              const mergedTasks = [...sortedOverDueTasks, ...sortedTasks];
              this.activeListing.set(currentDateKey, mergedTasks);
            }

            // Load profile pictures for overdue tasks
            allOverdueTasks.forEach(task => {
              if (task.assignedToEmail) {
                this.loadProfilePicture(task.assignedToEmail);
              }
            });
          }
        }

        if (this.durationSelected === "Weekly") {
          // Sort tasks for each date by sortOrder
          this.activeListing.forEach((tasks, date) => {
            const sortedTasks = tasks.sort((a, b) => {
              const sortOrderA = a.sortOrder || 0;
              const sortOrderB = b.sortOrder || 0;

              // Tasks with sortOrder come before those without
              if (sortOrderA > 0 && sortOrderB === 0) {
                return -1;
              }
              if (sortOrderA === 0 && sortOrderB > 0) {
                return 1;
              }

              // Both have sortOrder or both don't - sort by sortOrder value
              return sortOrderA - sortOrderB;
            });
            this.activeListing.set(date, sortedTasks);
          });
        }

        this.tasksArray = Array.from(this.activeListing, ([date, tasks]) => ({
          date,
          tasks,
        }));
        this._loaderService.setLoaderState(false);

        // Restore scroll position after data loads if needed
        if (this.shouldRestoreScroll) {
          this.restoreScrollPosition();
        }
        // Restore overdue scroll position after data loads if needed
        if (this.shouldRestoreOverdueScroll) {
          this.restoreOverdueScrollPosition();
        }
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Listed Tasks");
        this._loaderService.setLoaderState(false);
        this.shouldRestoreScroll = false;
        this.shouldRestoreOverdueScroll = false;
      },
    });
  }

  /**
   * Sort tasks for Daily view: Custom sort order first, then overdue, then by priority
   * Priority order: Urgent (1), Order (2), Source (3), Standard (4), No Priority (0)
   */
  private sortDailyTasks(tasks: GetAllTaskResponse[]): GetAllTaskResponse[] {
    return tasks.sort((a, b) => {
      // First, sort by custom sort order if both have one
      const sortOrderA = a.sortOrder || 0;
      const sortOrderB = b.sortOrder || 0;

      // If both have custom sort orders, use them
      if (sortOrderA > 0 && sortOrderB > 0) {
        return sortOrderA - sortOrderB;
      }

      // Tasks with sort order come before those without
      if (sortOrderA > 0 && sortOrderB === 0) {
        return -1;
      }
      if (sortOrderA === 0 && sortOrderB > 0) {
        return 1;
      }

      // Then sort by overdue status (overdue tasks first)
      if (a.dueDatePassed !== b.dueDatePassed) {
        return a.dueDatePassed ? -1 : 1;
      }

      // Then sort by priority
      const priorityA = a.priorityType || 999; // No priority goes last
      const priorityB = b.priorityType || 999; // No priority goes last

      return priorityA - priorityB;
    });
  }

  /**
   * Load more overdue tasks for infinite scroll
   */
  loadMoreOverdueTasks() {
    if (!this.hasMoreOverdueTasks || this.isLoadingMoreOverdue) {
      return;
    }

    this.isLoadingMoreOverdue = true;
    this.overduePageNumber++;

    const overdueRequest: GetOverdueTasksRequestDto = {
      pageNumber: this.overduePageNumber,
      pageSize: this.overduePageSize,
      isAllOverdue: true,
      myTask: this.myTasks,
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      archivedTask: this.archivedTasks,
      filters: this.currentFilters,
    };

    this._taskManagement.getOverdueTasks(overdueRequest).subscribe({
      next: res => {
        if (res?.data) {
          const newTasks = this.convertToGetAllTaskResponse(res.data);
          this.overdueTasks = [...this.overdueTasks, ...newTasks];
          this.hasMoreOverdueTasks =
            this.overdueTasks.length < this.totalOverdueRecords;

          // Load profile pictures for new tasks
          newTasks.forEach(task => {
            if (task.assignedToEmail) {
              this.loadProfilePicture(task.assignedToEmail);
            }
          });
        }
        this.isLoadingMoreOverdue = false;
      },
      error: () => {
        this._toastr.error("Error", "Unable to load more overdue tasks");
        this.isLoadingMoreOverdue = false;
        this.overduePageNumber--; // Revert page number on error
      },
    });
  }

  /**
   * Convert GetTaskListDto[] to GetAllTaskResponse[]
   * This is a mapper function since the APIs return different types
   */
  private convertToGetAllTaskResponse(
    taskListDto: GetTaskListDto[]
  ): GetAllTaskResponse[] {
    // Assuming the API actually returns GetAllTaskResponse[] format
    // If it returns GetTaskListDto[], you'll need proper mapping here
    const tasks = taskListDto as GetAllTaskResponse[];
    // Initialize calendarDueDate for each task
    tasks.forEach(task => {
      if (task.dueDate) {
        task.calendarDueDate = new Date(task.dueDate);
      }
    });
    return tasks;
  }

  formatDateToString(date: Date, format = "MM/dd/yyyy"): string {
    return this.datePipe.transform(date, format) ?? "";
  }

  getFromDate(): Date {
    const date = new Date(this.startDate);
    if (this.durationSelected === "Weekly") {
      // For Weekly view, use startDate as-is (should be today on initial load)
      // No adjustment needed - will show today, tomorrow, day after tomorrow
    } else if (this.durationSelected === "Monthly") {
      // Set to the first day of the month
      date.setDate(1);
    }
    // Set time to midnight (00:00:00.000) in local time
    //date.setHours(0, 0, 0, 0);
    return date;
  }

  getToDate(): Date {
    const fromDate = this.getFromDate();
    const toDate = new Date(fromDate);

    if (this.durationSelected === "Weekly") {
      // For 4-swimlane view: FromDate + 2 days = 3 days total
      // Example: If FromDate is 25 Feb (Today), ToDate is 27 Feb (Day After Tomorrow)
      // This fetches data for: 25 Feb, 26 Feb, 27 Feb (3 days only)
      toDate.setDate(toDate.getDate() + 2);
    } else if (this.durationSelected === "Monthly") {
      // Move to the next month and go back one day to get the last day of the current month
      toDate.setMonth(fromDate.getMonth() + 1);
      toDate.setDate(0); // Last day of the previous month
    }
    //toDate.setHours(0, 0, 0, 0);
    return toDate;
  }

  getDisplayDate(): Date {
    // Returns the date for display purposes in local timezone
    const date = new Date(this.startDate);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  getDatesBetween(): Date[] {
    const fromDate = this.getFromDate();
    const toDate = this.getToDate();

    const dates: Date[] = [];
    const currentDate = new Date(fromDate);

    while (currentDate <= toDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
      currentDate.setHours(0, 0, 0, 0);
    }

    return dates;
  }

  paginateLeft() {
    if (this.durationSelected === "Weekly") {
      // For 4-swimlane view: go back 3 days from current displayed date
      this.startDate.setDate(this.startDate.getDate() - 3);
    } else if (this.durationSelected === "Daily") {
      this.startDate.setDate(this.startDate.getDate() - 1); // Go back one day
    }
    this.getAllTaskList(this.globalFilter);
  }

  paginateRight() {
    if (this.durationSelected === "Weekly") {
      // For 4-swimlane view: go forward 3 days from current displayed date
      this.startDate.setDate(this.startDate.getDate() + 3);
    } else if (this.durationSelected === "Daily") {
      this.startDate.setDate(this.startDate.getDate() + 1); // Go forward one day
    }
    this.getAllTaskList(this.globalFilter);
  }

  formatHeadDate(dateString: string, durationSelected: string) {
    const date = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0);

    if (
      durationSelected === "Weekly" &&
      inputDate.getTime() === today.getTime()
    ) {
      return "Today";
    } else if (
      durationSelected === "Weekly" &&
      inputDate.getTime() === tomorrow.getTime()
    ) {
      return "Tomorrow";
    } else {
      return date.toLocaleDateString("en-US", {
        weekday: "long",
        month: "short",
        day: "numeric",
      });
    }
  }

  // getRelativeDateLabel(dateString: string): string {
  //   // Return formatted date like "Wednesday, Feb 25"
  //   return this.formatHeadDate(dateString, this.durationSelected);
  // }

  formatBodyDate(dateString: string) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  getTaskTypeTitle(taskType: number) {
    return this.taskTypeKey[taskType];
  }

  getPaddedWorkflowId(workflowId: number) {
    return workflowId?.toString().padStart(6, "0");
  }

  closeTaskDetailModal(event: {
    added: boolean;
    actionType: "Add" | "Edit";
    hasFormChanged: boolean;
  }) {
    this.displayTaskDetailModal = false;
    if (event.hasFormChanged || event.actionType === "Add") {
      this.saveScrollPosition();
      this.saveScrollOverDuePosition();
      this.getAllTaskList(this.lazyLoadEvent);
    }
  }

  redirectToTaskSummary(task: number) {
    this.displayTaskDetailModal = true;
    this.taskIdSelected = task;
  }

  redirectToEditTask(task: number) {
    this.displayAddTaskModal = true;
    this.taskIdSelected = task;
  }

  showEditTask() {
    this.showEditTaskModal = !this.showEditTaskModal;
  }

  showTaskDetailModal() {
    this.displayTaskDetailModal = true;
  }

  getColor(name: string) {
    return getColorForName(name);
  }

  getTextColor(name: string) {
    return getTextColorForName(name);
  }

  isTaskType(taskId: number, type: TaskTypeEnum): boolean {
    return taskId === type;
  }

  nextMonth() {
    this.fullCalendar.getApi().next();
    this.startDate = this.fullCalendar.getApi().getCurrentData().currentDate;
    this.getAllTaskList(this.globalFilter);
  }

  prevMonth() {
    this.fullCalendar.getApi().prev();
    this.startDate = this.fullCalendar.getApi().getCurrentData().currentDate;
    this.getAllTaskList(this.globalFilter);
  }

  today() {
    this.fullCalendar.getApi().today();
    this.startDate = this.fullCalendar.getApi().getCurrentData().currentDate;
    this.getAllTaskList(this.globalFilter);
  }

  getTaskStatusTitleSales(taskStatus: number) {
    return this.taskStatusKeyPairsSales[taskStatus];
  }

  getTaskStatusTitleProduction(taskStatus: number) {
    return this.taskStatusKeyPairsProduction[taskStatus];
  }

  getPriorityTypeTitle(priorityType: number, taskType: number) {
    if (taskType === TaskTypeEnum.Sales) {
      return this.priorityLevelSales[priorityType];
    } else {
      return this.priorityLevelProduction[priorityType];
    }
  }

  getPriorityColor(priorityType: number, taskType: number) {
    if (taskType === TaskTypeEnum.Sales) {
      return this.priorityColorSales[priorityType];
    } else {
      return this.priorityColorProduction[priorityType];
    }
  }

  // getPriorityBorderClass(priorityType: number, taskType: number): string {
  //   // Return a CSS class name based on priority
  //   if (taskType === TaskTypeEnum.Sales) {
  //     switch (priorityType) {
  //       case PriorityTypeEnums.Urgent:
  //         return "border-priority-sales-urgent";
  //       case PriorityTypeEnums.Source:
  //         return "border-priority-sales-source";
  //       case PriorityTypeEnums.Order:
  //         return "border-priority-sales-order";
  //       case PriorityTypeEnums.Standard:
  //         return "border-priority-sales-standard";
  //       default:
  //         return "border-priority-default";
  //     }
  //   } else {
  //     switch (priorityType) {
  //       case PriorityTypeEnums.Urgent:
  //         return "border-priority-production-urgent";
  //       case PriorityTypeEnums.Standard:
  //         return "border-priority-production-standard";
  //       default:
  //         return "border-priority-default";
  //     }
  //   }
  // }

  getPriorityTextColor(priorityType: number) {
    if (priorityType === Number(PriorityTypeEnums.Standard)) {
      return "#00000";
    } else {
      return "#ffff";
    }
  }

  smallView() {
    this.small = true;
    this.medium = false;
    this.large = false;
    this.fullCalendar.getApi().setOption("height", 600);
    this.fullCalendar.getApi().setOption("contentHeight", 500);
  }

  mediumView() {
    this.small = false;
    this.medium = true;
    this.large = false;
    this.fullCalendar.getApi().setOption("height", 700);
    this.fullCalendar.getApi().setOption("contentHeight", 600);
  }

  largeView() {
    this.small = false;
    this.medium = false;
    this.large = true;
    this.fullCalendar.getApi().setOption("height", 800);
    this.fullCalendar.getApi().setOption("contentHeight", 700);
  }

  isPriorityType(value: number) {
    return Object.values(PriorityTypeEnums).includes(value);
  }

  @HostListener("window:resize")
  onWindowResize(): void {
    this.visibleDays = window.innerWidth <= 1366 ? 2 : 3;
  }

  @HostListener("mouseenter", ["$event"])
  onMouseMove(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const avatarGroup = target.closest(".circle-name");
    const avatarUser = target.closest(".event-title-user");
    const popoverElement = target.closest(".p-popover");

    if (
      !avatarGroup &&
      !avatarUser &&
      !popoverElement &&
      this.avatarUserPopover?.overlayVisible
    ) {
      this.hideAvatarPopover();
    }
  }

  showAvatarPopover(
    event: MouseEvent,
    userId: number | null | undefined
  ): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }

    this.currentAvatarTarget = event.currentTarget as HTMLElement;

    // First set up the content and show the popover
    this.showUserAvatarDetails = true;
    this.getTooltipContent(userId);

    // Wait a short moment for the content to be rendered, then show popover
    setTimeout(() => {
      if (this.avatarUserPopover && this.currentAvatarTarget) {
        this.avatarUserPopover.show(event, this.currentAvatarTarget);
      }
    }, 100);
  }

  hideAvatarPopover(): void {
    this.hideTimeout = setTimeout(() => {
      if (this.avatarUserPopover) {
        this.avatarUserPopover.hide();
      }
      this.onAvatarLeave();
    }, 200);
  }

  keepPopoverOpen(): void {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  getTooltipContent(obj: number | null | undefined) {
    if (obj && obj > 0) {
      this.getUserAvatarDetailsByUserId(obj);
    }
  }

  onAvatarLeave() {
    this.clearAvatarDetails();
    this.showUserAvatarDetails = false;
    this.currentAvatarTarget = null;
  }

  clearAvatarDetails() {
    this.userAvatorDetails = {} as avatarUserDetailsDto;
    this.userAvatorDetails = {
      name: "",
      email: "",
      personalNumber: "",
      locationName: "",
      profileImageUrl: "../../../assets/images/avatar-default.webp",
    } as avatarUserDetailsDto;
  }

  getUserAvatarDetailsByUserId(userId: number) {
    this.isLoading = true;
    this._profileFormService.GetUserAvatarDetailsByUserId(userId).subscribe({
      next: async (res: GenericResponseDto<GetUserAvatarDetailsDto>) => {
        if (res.data != null) {
          this.userAvatorDetails.name = res.data.name ?? "";
          this.userAvatorDetails.email = res.data.email ?? "";
          this.userAvatorDetails.personalNumber =
            res.data.personnelNumber ?? "";
          this.userAvatorDetails.locationName = res.data.locationName ?? "";

          // Check if profile picture is already cached
          const email = res.data.email ?? "";
          if (email && this.profilePictures.has(email)) {
            // Use cached profile picture
            this.userAvatorDetails.profileImageUrl =
              this.profilePictures.get(email)!;
            this.isLoading = false;
          } else if (email) {
            // Load profile picture and wait for it to be cached
            this.userAvatorDetails.profileImageUrl =
              "../../../assets/images/avatar-default.webp";
            this.loadProfilePicture(email, true);
          } else {
            this.isLoading = false;
          }
          this.showUserAvatarDetails = true;
        }
      },
      error: () => {
        this.showUserAvatarDetails = false;
        this.isLoading = false;
      },
    });
  }

  /**
   * Load profile picture for an email address
   * @param email - The email address to load the profile picture for
   * @param updateAvatarDetails - If true, also update userAvatorDetails and isLoading flag
   */
  loadProfilePicture(email: string, updateAvatarDetails = false): void {
    if (!email || this.profilePictures.has(email)) {
      // If already cached and we need to update avatar details, do it now
      if (updateAvatarDetails && this.profilePictures.has(email)) {
        this.userAvatorDetails.profileImageUrl =
          this.profilePictures.get(email)!;
        this.isLoading = false;
      }
      return;
    }
    this.profilePictures.set(email, null);
    this._msalApiService.getUserProfilePicture(email).subscribe({
      next: (blob: Blob) => {
        const objectURL = URL.createObjectURL(blob);
        const safeUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);

        this.profilePictures.set(email, safeUrl);

        // Update avatar details if requested (for popover display)
        if (updateAvatarDetails) {
          this.userAvatorDetails.profileImageUrl = safeUrl;
          this.isLoading = false;
        }
      },
      error: () => {
        // Profile picture not available, will show initials
        if (updateAvatarDetails) {
          this.userAvatorDetails.profileImageUrl =
            "../../../assets/images/avatar-default.webp";
          this.isLoading = false;
        }
        this.profilePictures.set(email, null);
      },
    });
  }

  getInitials(name: string): string {
    if (!name || name.trim() === "") return "";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    else if (parts.length === 3) {
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    }
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  }

  getProfilePicture(email: string): SafeUrl | null {
    return this.profilePictures.get(email) ?? null;
  }

  copyTaskFn(taskId: number, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.confirmationService.confirm({
      message: `Are you sure you want to copy this task?`,
      accept: () => {
        this._loaderService.setLoaderState(true);
        this._taskManagement.CopyTask(taskId).subscribe({
          next: res => {
            if (res && res.status.toLowerCase() === "success") {
              this._toastr.success("Success", "Task copied successfully.");
              // Refresh the task list to show the new copied task
              this.getAllTaskList(this.globalFilter);
            } else {
              this._toastr.error("Error", "Failed to copy task.");
            }
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._toastr.error("Error", "Failed to copy task.");
            this._loaderService.setLoaderState(false);
          },
        });
      },
    });
  }

  /**
   * Copy PO Number to clipboard
   * @param poNumber - The PO Number to copy
   * @param event - Optional event to stop propagation
   */
  copyPoNumber(poNumber: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    if (!poNumber || poNumber.trim() === "") {
      this._toastr.warning("Warning", "No PO Number to copy.");
      return;
    }

    navigator.clipboard.writeText(poNumber).then(
      () => {
        this._toastr.success("Success", "PO Number copied to clipboard.");
      },
      () => {
        this._toastr.error("Error", "Failed to copy PO Number.");
      }
    );
  }

  /**
   * Drag start handler for task cards
   * @param task - The task being dragged
   * @param fromDate - The date swimlane the task is being dragged from (null for overdue)
   * @param isOverdue - Whether the task is being dragged from the overdue column
   */
  onDragStart(
    task: GetAllTaskResponse,
    fromDate: string | null = null,
    isOverdue = false
  ) {
    if (task.isExternal && !task.isAdmin) {
      return; // Don't allow dragging external tasks
    }
    this.draggedTask = task;
    this.draggedFromDate = fromDate;
    this.draggedFromOverdue = isOverdue;
  }

  /**
   * Drag end handler - resets drag state
   */
  onDragEnd() {
    this.draggedTask = null;
    this.draggedFromDate = null;
    this.draggedFromOverdue = false;
    this.dropIndex = 0;
  }

  /**
   * Track drop position when dragging over task cards
   * @param index - The index of the task being hovered over
   */
  onDragOver(index: number) {
    this.dropIndex = index;
  }

  /**
   * Drop handler for date-based swimlanes
   * Updates the task's due date when dropped to a different day
   * Or reorders tasks when dropped in the same swimlane
   * @param targetDate - The date of the target swimlane (format: 'YYYY-MM-DD')
   * @param dropIndex - The index position where the task was dropped (optional)
   */
  onDropToSwimlane(targetDate: string, dropIndex?: number) {
    if (!this.draggedTask) {
      return;
    }

    const task = this.draggedTask;
    const isSameSwimlane =
      this.draggedFromDate === targetDate && !this.draggedFromOverdue;

    // Same swimlane - reorder tasks
    if (isSameSwimlane && dropIndex !== undefined) {
      this.reorderTasksInSwimlane(targetDate, task, dropIndex);
      this.onDragEnd();
      return;
    }

    // Different swimlane - change due date
    if (!isSameSwimlane) {
      // Parse target date and create new due date
      const newDueDate = new Date(targetDate);
      newDueDate.setHours(12, 0, 0, 0); // Set to noon to avoid timezone issues

      // Update task's calendarDueDate for the API call
      task.calendarDueDate = newDueDate;

      // Use the existing onTaskFieldEdit method to update the due date
      this.onTaskFieldEdit(task, "calendarDueDate");
    }

    this.onDragEnd();
  }

  /**
   * Reorder tasks within a swimlane and persist the new sort order
   * @param targetDate - The date of the swimlane
   * @param task - The task being moved
   * @param newIndex - The new position index for the task
   */
  reorderTasksInSwimlane(
    targetDate: string,
    task: GetAllTaskResponse,
    newIndex: number
  ) {
    // Find the swimlane entry in tasksArray
    const swimlaneEntry = this.tasksArray.find(
      entry => entry.date === targetDate
    );
    if (!swimlaneEntry) {
      return;
    }

    const tasks = swimlaneEntry.tasks;

    // Find current index of the task
    const currentIndex = tasks.findIndex(t => t.taskId === task.taskId);
    if (currentIndex === -1 || currentIndex === newIndex) {
      return;
    }

    // Remove task from current position and insert at new position
    tasks.splice(currentIndex, 1);
    tasks.splice(newIndex, 0, task);

    // Update sort order for all tasks in the swimlane
    tasks.forEach((t, index) => {
      t.sortOrder = index + 1;
    });

    // Build request payload for API
    const request: AddTaskOrder[] = tasks.map(t => ({
      TaskId: t.taskId,
      DueDate: this.datePipe.transform(t.dueDate, "yyyy-MM-dd"),
      PriorityType: t.priorityType,
      SortOrder: t.sortOrder,
      ProjectHeaderId: t.projectWorkflowId,
    }));

    // Save to backend
    this._taskManagement.updateTaskOrder(request).subscribe({
      next: res => {
        if (res && res.status === "Success") {
          this._toastr.success("Success", "Task order updated");
        } else {
          this._toastr.error("Error", "Failed to update task order");
          // Refresh to restore original order on failure
          this.getAllTaskList(this.globalFilter);
        }
      },
      error: () => {
        this._toastr.error("Error", "Failed to update task order");
        this.getAllTaskList(this.globalFilter);
      },
    });
  }

  /**
   * Reorder tasks within the overdue column
   * @param task - The task being moved
   * @param newIndex - The new position index for the task
   */
  reorderOverdueTasks(task: GetAllTaskResponse, newIndex: number) {
    const tasks = this.overdueTasks;

    // Find current index of the task
    const currentIndex = tasks.findIndex(t => t.taskId === task.taskId);
    if (currentIndex === -1 || currentIndex === newIndex) {
      return;
    }

    // Remove task from current position and insert at new position
    tasks.splice(currentIndex, 1);
    tasks.splice(newIndex, 0, task);

    // Update sort order for all tasks in overdue
    tasks.forEach((t, index) => {
      t.sortOrder = index + 1;
    });

    // Build request payload for API
    const request: AddTaskOrder[] = tasks.map(t => ({
      TaskId: t.taskId,
      DueDate: this.datePipe.transform(t.dueDate, "yyyy-MM-dd"),
      PriorityType: t.priorityType,
      SortOrder: t.sortOrder,
      ProjectHeaderId: t.projectWorkflowId,
    }));

    // Save to backend
    this._taskManagement.updateTaskOrder(request).subscribe({
      next: res => {
        if (res && res.status === "Success") {
          this._toastr.success("Success", "Task order updated");
        } else {
          this._toastr.error("Error", "Failed to update task order");
          this.getAllTaskList(this.globalFilter);
        }
      },
      error: () => {
        this._toastr.error("Error", "Failed to update task order");
        this.getAllTaskList(this.globalFilter);
      },
    });
  }

  /**
   * Drop handler for overdue column reordering
   * @param dropIndex - The index where task is dropped
   */
  onDropToOverdue(dropIndex?: number) {
    if (!this.draggedTask || !this.draggedFromOverdue) {
      this.onDragEnd();
      return;
    }

    if (dropIndex !== undefined) {
      this.reorderOverdueTasks(this.draggedTask, dropIndex);
    }

    this.onDragEnd();
  }

  /**
   * Handle scroll event for overdue tasks infinite scroll
   */
  onOverdueScroll(event: Event) {
    const element = event.target as HTMLElement;
    const atBottom =
      element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

    if (atBottom && this.hasMoreOverdueTasks && !this.isLoadingMoreOverdue) {
      this.loadMoreOverdueTasks();
    }
  }

  /**
   * Lightens a hex color by a given percentage
   * @param hexColor - The hex color to lighten (e.g., '#FF6B6B' or 'FF6B6B')
   * @param percent - The percentage to lighten (0-100), default is 70
   * @returns The lightened hex color
   */
  lightenColor(hexColor: string, percent = 70): string {
    if (!hexColor) return "#FFFFFF";

    // Remove # if present
    let hex = hexColor.replace("#", "");

    // Handle shorthand hex (e.g., 'FFF')
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    // Parse RGB values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Lighten each channel
    const lightenChannel = (channel: number): number => {
      return Math.round(channel + (255 - channel) * (percent / 100));
    };

    const newR = lightenChannel(r);
    const newG = lightenChannel(g);
    const newB = lightenChannel(b);

    // Convert back to hex
    const toHex = (value: number): string => {
      const hex = value.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };

    return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
  }

  /**
   * Returns the lightened background color for a tag
   * @param tagColor - The original tag color from the database
   * @returns The lightened color for background
   */
  getTagBackgroundColor(tagColor: string): string {
    return this.lightenColor(tagColor, 85);
  }

  /**
   * Returns the original color for font/text
   * @param tagColor - The original tag color from the database
   * @returns The original color for text
   */
  getTagTextColor(tagColor: string): string {
    return tagColor || "#000000";
  }

  /**
   * Enable title editing mode for a task
   */
  enableTitleEdit(task: GetAllTaskResponse, viewType = ""): void {
    this.editingTaskId = task.taskId;
    this.originalTitle = task.title;
    setTimeout(() => {
      if (viewType === "daily") {
        const input = document.querySelector(
          "input.dailyInput"
        )! as HTMLInputElement;
        if (input) {
          input.focus();
        }
      } else {
        const input = document.querySelector(
          "input.protitle-text"
        )! as HTMLInputElement;
        if (input) {
          input.focus();
        }
      }
    }, 0);
  }

  /**
   * Check if a task's title is currently being edited
   */
  isTitleEditing(taskId: number): boolean {
    return this.editingTaskId === taskId;
  }

  /**
   * Focus handler for title input
   */
  onTitleFocus(task: GetAllTaskResponse): void {
    this.originalTitle = task.title;
  }

  /**
   * Mouse down handler for title input to prevent drag behavior
   */
  onTitleMouseDown(event: MouseEvent): void {
    event.stopPropagation();
    const input = event.target as HTMLInputElement;
    input.setPointerCapture((event as PointerEvent).pointerId || 1);
  }

  /**
   * Mouse up handler for title input
   */
  onTitleMouseUp(event: MouseEvent): void {
    const input = event.target as HTMLInputElement;
    if (input.hasPointerCapture((event as PointerEvent).pointerId || 1)) {
      input.releasePointerCapture((event as PointerEvent).pointerId || 1);
    }
  }

  /**
   * Handle task field editing (title, etc.)
   */
  onTaskFieldEdit(task: GetAllTaskResponse, column: string): void {
    if (column === "title" && task.title.trim() === "") {
      this._toastr.error("Error", "Task Title should not be empty");
      task.title = this.originalTitle ?? "";
      this.editingTaskId = null;
      return;
    } else if (column === "title" && this.originalTitle === task.title) {
      this.editingTaskId = null;
      return;
    }

    // Handle date field formatting
    if (column === "calendarDueDate" && task.calendarDueDate) {
      const dateValue = task.calendarDueDate;
      const inputDate = new Date(dateValue);
      const localDate = new Date(
        inputDate.getFullYear(),
        inputDate.getMonth(),
        inputDate.getDate()
      );
      const formattedDate = this.datePipe.transform(
        localDate,
        "yyyy-MM-dd HH:mm:ss.SSS"
      );
      task.calendarDueDate = formattedDate
        ? new Date(formattedDate)
        : new Date();
    }

    this._loaderService.setLoaderState(true);

    // Get the correct value for date fields to avoid timezone issues
    let payloadValue = null;
    if (column === "calendarDueDate") {
      const dateValue = task.calendarDueDate;
      if (dateValue) {
        const inputDate = new Date(dateValue);
        const localDate = new Date(
          inputDate.getFullYear(),
          inputDate.getMonth(),
          inputDate.getDate()
        );
        payloadValue = this.datePipe.transform(
          localDate,
          "yyyy-MM-dd HH:mm:ss.SSS"
        );
      }
    } else {
      payloadValue = task[column as keyof GetAllTaskResponse];
    }

    const payload = {
      taskId: task.taskId,
      column: column === "calendarDueDate" ? "dueDate" : column,
      value: payloadValue,
      lineRecId: task.lineRecId ?? 0,
      saleOrderId: task.salesOrderId,
      isBuyerChange: false,
    } as UpdateTaskLine;

    this._taskManagement.UpdateTaskLine(payload).subscribe({
      next: async res => {
        if (res && res.status.toLowerCase() === "success") {
          if (column === "title") {
            // Title is already updated locally via ngModel - no re-fetch needed
            this.sendComment(task.title, task.taskId);
            this._loaderService.setLoaderState(false);
            this._toastr.success("Success", "Task Updated Successfully");
            this.editingTaskId = null;
            return;
          }
          this.saveScrollPosition();
          this.saveScrollOverDuePosition();
          if (column === "calendarDueDate") {
            this.sendComment("Due date updated", task.taskId);
          }
          this._loaderService.setLoaderState(false);
          this._toastr.success("Success", "Task Updated Successfully");
          this.editingTaskId = null;
          this.getAllTaskList(this.globalFilter);
        } else {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed to Update Task");
          if (column === "title") {
            task.title = this.originalTitle ?? "";
          }
          this.editingTaskId = null;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed to Update Task");
        if (column === "title") {
          task.title = this.originalTitle ?? "";
        }
        this.editingTaskId = null;
      },
    });
  }

  /**
   * Send a comment when task is updated
   */
  sendComment(comment: string, taskId: number): boolean {
    let status = false;
    if (taskId) {
      const commentPayload = {
        comment: comment,
        taskId: taskId,
      } as createCommentDto;
      this._taskManagement.addCommentinTask(commentPayload).subscribe({
        next: async res => {
          if (res.status.toLowerCase() === "success") {
            status = true;
          }
        },
      });
    }
    return status;
  }

  /**
   * Get sales task status list for dropdown
   */
  getSalesTaskAsList() {
    return Object.entries(EnumSalesTaskStatus)
      .filter(([key]) => isNaN(Number(key)))
      .map(([key, value]) => ({
        label: key.replace(/([a-z])([A-Z])/g, "$1 $2"),
        value,
      }));
  }

  /**
   * Get workflow status list from backend for production tasks
   */
  getWorkflowStatusList() {
    this._workflowService.getWorkflowStatusList().subscribe({
      next: res => {
        this.workflowStatusList = {};
        this.prodStatusDropDownList = [];
        const statusEnums: Record<string, number> = {};
        if (res?.data) {
          res.data.forEach((status: { status: string; id: number }) => {
            if (status.id !== 9) {
              statusEnums[status.status] = status.id;
              this.prodStatusDropDownList.push({
                label: status.status,
                value: status.id,
              });
            }
          });
          this.workflowStatusList = statusEnums;
        }
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Status List");
      },
    });
  }

  /**
   * Open status popover and store product data
   */
  openStatusPopover(
    event: Event,
    product: GetAllTaskResponse,
    target: HTMLElement
  ) {
    event.stopPropagation();
    this.currentProductForStatus = product;
    this.statusOverlay.toggle(event, target);
  }

  /**
   * Handle status dropdown change
   */
  onStatusDropDownChange(
    taskId: number,
    value: string | EnumSalesTaskStatus | number,
    taskType: number
  ) {
    if (taskId && value !== null && value !== undefined) {
      // Convert value to number
      const statusValue =
        typeof value === "string" ? parseInt(value, 10) : Number(value);

      this._loaderService.setLoaderState(true);
      this._taskManagement.updateStatus(taskId, statusValue).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() === "success") {
            this.sendComment(
              `Status changed: ${
                taskType === 1
                  ? this.getTaskStatusTitleSales(statusValue)
                  : this.getTaskStatusTitleProduction(statusValue)
              }`,
              taskId
            );
            this._toastr.success(
              "You have successfully updated the Status",
              "Success"
            );
            this.saveScrollPosition();
            this.saveScrollOverDuePosition();
            this.getAllTaskList(this.globalFilter);
          } else {
            this._toastr.error("Error updating the status", "Error");
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed to Update Task Status");
        },
      });
    }
  }

  /**
   * Save current scroll position before API call
   */
  private saveScrollPosition(): void {
    this.savedScrollPositions = [];
    if (this.scrollContainers) {
      this.scrollContainers.forEach(container => {
        this.savedScrollPositions.push({
          scrollTop: container.nativeElement.scrollTop,
          scrollLeft: container.nativeElement.scrollLeft,
        });
      });
      this.shouldRestoreScroll = true;
    }
  }

  /**
   * Restore scroll position after data loads
   */
  private restoreScrollPosition(): void {
    if (this.scrollContainers && this.savedScrollPositions.length > 0) {
      // Use setTimeout to ensure DOM is updated before scrolling
      setTimeout(() => {
        this.scrollContainers.forEach((container, index) => {
          if (this.savedScrollPositions[index]) {
            container.nativeElement.scrollTop =
              this.savedScrollPositions[index].scrollTop;
            container.nativeElement.scrollLeft =
              this.savedScrollPositions[index].scrollLeft;
          }
        });
        this.shouldRestoreScroll = false;
      }, 500);
    } else {
      this.shouldRestoreScroll = false;
    }
  }

  getOnlyDateString(date: Date | string): string {
    if (typeof date === "string") {
      date = new Date(date);
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const localDate = `${year}-${month}-${day}`;
    return localDate;
  }

  showContactDialog(client: string) {
    if (client !== "") {
      this.emitShowContactDialog.emit(client);
    }
  }

  showOrderSummaryModal(salesOrderId: string) {
    this.emitShowSalesOrderSummaryModal.emit(salesOrderId);
  }

  openWorkflowSummary({
    salesOrderId,
    workflowId,
  }: {
    salesOrderId: string;
    workflowId: number;
  }) {
    if (salesOrderId !== "" && workflowId) {
      this.emitShowWorkflowSummaryModal.emit({ salesOrderId, workflowId });
    }
  }

  archiveEvent(task: GetAllTaskResponse, status: boolean) {
    const eventTxt = status ? "Archived" : "UnArchived";
    this.archiveMessage = replaceString(
      this.archiveMessage,
      task.title,
      eventTxt
    );
    this.archivedTask = task.taskId;
    this.archivedTaskStatus = status;
    this.archiveAlertVisible = true;
  }

  confirmArchive(event: boolean) {
    this.archiveAlertVisible = false;
    this.archiveMessage = "You want to mark <b>{0}</b> as {1}.";
    if (event && this.archivedTask) {
      const payload = {
        taskId: this.archivedTask,
        archive: this.archivedTaskStatus,
      };
      this._taskManagement.MarkAsArchive(payload).subscribe({
        next: async res => {
          if (res && res.status.toLowerCase() === "success") {
            this._toastr.success(
              "Success",
              "Task archive status has been changed"
            );
            this.getAllTaskList(this.lazyLoadEvent);
          } else {
            this._toastr.error("Error", "Failed to Update Task");
          }
        },
        error: () => {
          this._toastr.error("Error", "Failed to Update Task");
        },
      });
    }
  }

  /**
   * Save current scroll position before API call
   */
  private saveScrollOverDuePosition(): void {
    if (this.scrollOverDueContainer?.nativeElement) {
      this.savedOverdueScrollTop =
        this.scrollOverDueContainer.nativeElement.scrollTop;
      this.savedOverdueScrollLeft =
        this.scrollOverDueContainer.nativeElement.scrollLeft;
      this.shouldRestoreOverdueScroll = true;
    }
  }

  /**
   * Restore scroll position after data loads
   */
  private restoreOverdueScrollPosition(): void {
    if (this.scrollOverDueContainer?.nativeElement) {
      // Use setTimeout to ensure DOM is updated before scrolling
      setTimeout(() => {
        this.scrollOverDueContainer.nativeElement.scrollTop =
          this.savedOverdueScrollTop;
        this.scrollOverDueContainer.nativeElement.scrollLeft =
          this.savedOverdueScrollLeft;
        this.shouldRestoreOverdueScroll = false;
      }, 500);
    } else {
      this.shouldRestoreOverdueScroll = false;
    }
  }

  populateContactAddedInfo(buyer: string) {
    this.taskHeaderEdit?.popolateBuyerNameAfterContactAdded(buyer);
  }

  openDatePicker(event: Event): void {
    event.stopPropagation();

    const target = event.target as HTMLElement;
    const wrapper = target.closest(".duedate-wrapper");

    if (wrapper) {
      // AI Claude: PrimeNG creates a button with class 'p-datepicker-trigger' for the calendar icon
      // This is the actual clickable element that opens the picker
      const triggerButton = wrapper.querySelector(
        "button.p-datepicker-trigger"
      )! as HTMLElement;
      if (triggerButton) {
        triggerButton.click();
        return;
      }

      // AI Claude: Fallback - try to find the input element and click it
      const input = wrapper.querySelector('input[type="text"]')! as HTMLElement;
      if (input) {
        input.click();
      }
    }
  }

  calendarViewSubSelection(): CalendarViewTypeSubSelectionEnum {
    switch (this.durationSelected) {
      case "Daily":
        return CalendarViewTypeSubSelectionEnum.Daily;
      case "Monthly":
        return CalendarViewTypeSubSelectionEnum.Monthly;
      default:
        return CalendarViewTypeSubSelectionEnum.Weekly;
    }
  }
}
